import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import { cadastro,auditoria } from '../../services/mysql'
import InputMask from 'react-input-mask';
import { cnpj, cpf } from 'cpf-cnpj-validator';

export default function Cadastro() {
    const [valorCpf, setValorCpf] = useState('')
    const [nome, setNome] = useState('')
    const [perfil, setPerfil] = useState('')
    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [confirmaSenha, setConfirmaSenha] = useState('')
    const [mostrarSenha, setMostrarSenha] = useState(false)
    const [mostrarConfirmaSenha, setMostrarConfirmaSenha] = useState(false)

    function realizaLogin() {
        if (!perfil) {
            mensagemAlerta('Escolha se você é Atleta ou Telespectador')
            return
        }
        if (!nome) {
            mensagemAlerta('Digite seu Nome')
            return
        }
        if (!cpf.isValid(valorCpf.replace(/[^a-z0-9]/gi, ''))) {
            mensagemAlerta('CPF inválido')
            return
        }
        if (!email) {
            mensagemAlerta('Digite seu Email')
            return
        }
        if (!senha) {
            mensagemAlerta('Digite sua Senha')
            return
        }
        if (!confirmaSenha) {
            mensagemAlerta('Confirme sua senha')
            return
        }
        if (senha !== confirmaSenha) {
            mensagemAlerta('As senhas não iguais')
            return
        }
        mensagemLoading('Buscando cadastrado..')
        const data = {
            nome: nome,
            cpf: valorCpf.replace(/[^a-z0-9]/gi, ''),
            email: email.toLocaleLowerCase(),
            senha: senha,
            perfil: perfil
        }
        cadastro(data).then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemAlerta(res.message)
            } else {
                mensagemSucesso('Cadastro realizado com sucesso! Realize login com seu email e senha')
                const data = {
                    idUsuario: res.id,
                    acao: 'Realizou o cadastro com sucesso '
                }
                auditoria(data);
            }
        })

    }

    const handleNome = (event) => {
        event.persist();
        setNome(event.target.value);
    }
    const handleCpf = (event) => {
        event.persist();
        setValorCpf(event.target.value);
    }
    const handleEmail = (event) => {
        event.persist();
        setEmail(event.target.value);
    }
    const handleSenha = (event) => {
        event.persist();
        setSenha(event.target.value);
    }
    const handleConfirmaSenha = (event) => {
        event.persist();
        setConfirmaSenha(event.target.value);
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(()=>{
            window.location = '/'
        })
    }
    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y">
                <div className="authentication-inner">
                    {/* Register */}
                    <div className="card">
                        <div className="card-body">
                            <img onClick={()=> window.location.href = 'https://tvcombate.com'} src='/images/tvcombate_logo_login.png' style={{ width: '100%' }} />
                            <h4 className="mb-2" style={{ marginTop: 20, textAlign: 'center' }}>Novo Cadastro</h4>
                            <p className="mb-4" style={{ marginTop: 20, textAlign: 'center' }}>Digite abaixo suas credenciais</p>
                            <div className="mb-3">
                                <div className="mb-3">
                                    <label htmlFor="perfil" className="form-label">Tipo de usuário</label>
                                    <select id="perfil" name="perfil" className="form-select" value={perfil} onChange={(event) => setPerfil(event.target.value)}>
                                        <option value="">Escolha seu perfil</option>
                                        <option value="ATLETA_PROFISSIONAL">Sou Atleta</option>
                                        <option value="ATLETA">Sou Telespectador</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Nome</label>
                                    <input type="text" value={nome} onChange={handleNome} className="form-control" id="email" name="email-username" placeholder="Seu nome" autofocus />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">CPF</label>
                                    <InputMask inputMode="numeric" type="tel" onChange={handleCpf} mask="999.999.999-99" class="form-control" maskChar={null} value={valorCpf} placeholder='000.000.000-00' />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input type="text" value={email.toLocaleLowerCase()} onChange={handleEmail} className="form-control" id="email" name="email-username" placeholder="Digite seu email" autofocus />
                                </div>
                                <div className="mb-3 form-password-toggle">
                                    <div className="d-flex justify-content-between">
                                        <label className="form-label" htmlFor="password">Senha</label>
                                    </div>
                                    <div className="input-group input-group-merge">
                                        <input value={senha} onChange={handleSenha} type={mostrarSenha ? 'text' : 'password'} id="password" className="form-control" name="password" placeholder="············" autoComplete="new-password" />
                                        <button type="button" className="input-group-text cursor-pointer" onClick={() => setMostrarSenha((valor) => !valor)} aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'} aria-pressed={mostrarSenha} aria-controls="password">
                                            <i className={`bx ${mostrarSenha ? 'bx-show' : 'bx-hide'}`} aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                                <div className="mb-3 form-password-toggle">
                                    <div className="d-flex justify-content-between">
                                        <label className="form-label" htmlFor="confirm-password">Confirme sua senha</label>
                                    </div>
                                    <div className="input-group input-group-merge">
                                        <input value={confirmaSenha} onChange={handleConfirmaSenha} type={mostrarConfirmaSenha ? 'text' : 'password'} id="confirm-password" className="form-control" name="confirm-password" placeholder="············" autoComplete="new-password" />
                                        <button type="button" className="input-group-text cursor-pointer" onClick={() => setMostrarConfirmaSenha((valor) => !valor)} aria-label={mostrarConfirmaSenha ? 'Ocultar confirmação de senha' : 'Mostrar confirmação de senha'} aria-pressed={mostrarConfirmaSenha} aria-controls="confirm-password">
                                            <i className={`bx ${mostrarConfirmaSenha ? 'bx-show' : 'bx-hide'}`} aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <button onClick={() => realizaLogin()} className="btn btn-primary d-grid w-100" type="submit">Cadastrar</button>
                                    <button onClick={() => window.location = '/'} className="btn btn-default d-grid w-100" type="submit">Já possui cadastro? Faça login</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
